var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.404 5.633.74 2.06a8.16 8.16 0 0 0 4.91 4.908l2.058.74a.211.211 0 0 1 0 .398l-2.059.74a8.16 8.16 0 0 0-4.908 4.909l-.741 2.059a.211.211 0 0 1-.397 0l-.741-2.06a8.16 8.16 0 0 0-4.909-4.908L.3 13.74a.211.211 0 0 1 0-.398l2.058-.74a8.16 8.16 0 0 0 4.909-4.909l.74-2.059a.21.21 0 0 1 .398 0z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.404 5.633.74 2.06a8.16 8.16 0 0 0 4.91 4.908l2.058.74a.211.211 0 0 1 0 .398l-2.059.74a8.16 8.16 0 0 0-4.908 4.909l-.741 2.059a.211.211 0 0 1-.397 0l-.741-2.06a8.16 8.16 0 0 0-4.909-4.908L.3 13.74a.211.211 0 0 1 0-.398l2.058-.74a8.16 8.16 0 0 0 4.909-4.909l.74-2.059a.21.21 0 0 1 .398 0z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.672.687.377 1.042a4.137 4.137 0 0 0 2.486 2.486l1.042.376a.106.106 0 0 1 0 .201l-1.043.376a4.137 4.137 0 0 0-2.485 2.486l-.377 1.042a.107.107 0 0 1-.2 0l-.377-1.042a4.137 4.137 0 0 0-2.486-2.486l-1.042-.376a.106.106 0 0 1 0-.2l1.042-.377a4.137 4.137 0 0 0 2.486-2.486l.376-1.042a.106.106 0 0 1 .201 0z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.672.687.377 1.042a4.137 4.137 0 0 0 2.486 2.486l1.042.376a.106.106 0 0 1 0 .201l-1.043.376a4.137 4.137 0 0 0-2.485 2.486l-.377 1.042a.107.107 0 0 1-.2 0l-.377-1.042a4.137 4.137 0 0 0-2.486-2.486l-1.042-.376a.106.106 0 0 1 0-.2l1.042-.377a4.137 4.137 0 0 0 2.486-2.486l.376-1.042a.106.106 0 0 1 .201 0z",
    fill: "#000",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.672 18.39.377 1.041a4.137 4.137 0 0 0 2.486 2.486l1.042.377a.106.106 0 0 1 0 .2l-1.043.377a4.137 4.137 0 0 0-2.485 2.486l-.377 1.042a.107.107 0 0 1-.2 0l-.377-1.042a4.137 4.137 0 0 0-2.486-2.486l-1.042-.377a.106.106 0 0 1 0-.2l1.042-.377a4.137 4.137 0 0 0 2.486-2.486l.376-1.042a.107.107 0 0 1 .201 0z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.672 18.39.377 1.041a4.137 4.137 0 0 0 2.486 2.486l1.042.377a.106.106 0 0 1 0 .2l-1.043.377a4.137 4.137 0 0 0-2.485 2.486l-.377 1.042a.107.107 0 0 1-.2 0l-.377-1.042a4.137 4.137 0 0 0-2.486-2.486l-1.042-.377a.106.106 0 0 1 0-.2l1.042-.377a4.137 4.137 0 0 0 2.486-2.486l.376-1.042a.107.107 0 0 1 .201 0z",
    fill: "#000",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateButton);
export default __webpack_public_path__ + "static/media/create-button.8fec7dc79dc77ec031980291ae6c1a64.svg";
export { ForwardRef as ReactComponent };